import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import {CardModalWindow} from '../SharedComponents/CardModalWindow';
import {CardModalContent} from '../SharedComponents/CardModalContent';
import {RenderHTML} from '@learningblocks/storybook-components';
import LightBulb from '@learningblocks/exp-constants/lib/Images/lighbulb.svg';
import MoveCard from '@learningblocks/exp-constants/lib/Images/move.svg';
import TrashCan from '@learningblocks/exp-constants/lib/Images/mini-trash-icon.svg';
import './style.scss';

/**
 * Experimental-Design FullWidthCard component:
 */
export function FullWidthCard(props) {
  const [isModalOpen, toggleModal] = useState(false);

  const setModalOpen = () => {
    toggleModal(true);
  };

  const setModalClose = () => {
    toggleModal(false);
  };

  const modalButton = () => (
    <div className='card-icons__modal' onClick={setModalOpen}>
      <Image src={LightBulb} alt='open-modal-window' />
    </div>
  );

  const addButton = () =>
    props.addCard && (
      <div className='card-icons__add' onClick={props.addCard}>
        <Image src={MoveCard} alt='add-card-option' />
      </div>
    );

  const removeButton = () =>
    props.removeCard && (
      <div className='card-icons__remove' onClick={props.removeCard}>
        <Image src={TrashCan} alt='trash-card-option' />
      </div>
    );

  return (
    <>
      <div className='card'>
        <div className='card-image'>
          <Image src={props.image} alt={props.title} />
        </div>
        <div className='card-content'>
          <RenderHTML content={props.title} />
          <RenderHTML content={props.description} />
        </div>
        <div className='card-icons'>
          {modalButton()}
          {addButton()}
          {removeButton()}
        </div>
      </div>
      <CardModalWindow
        isModalOpen={isModalOpen}
        modalTitle={props.modal.title}
        setModalClose={setModalClose}>
        <CardModalContent components={props.modal.components} />
      </CardModalWindow>
    </>
  );
}

FullWidthCard.propTypes = {
  /**
   * String representing type of component
   */
  type: PropTypes.string,
  /**
   * callback function to be executed when card is added as next step in DesignSection
   * Prop should be null if addCard icon not required
   */
  addCard: PropTypes.func,
  /**
   * callback function to be executed when card needs to be removed from design section tree
   * Prop should be null if removeCard icon not required
   */
  removeCard: PropTypes.func,
  /**
   * Url to the 1:1 Card image.
   */
  image: PropTypes.string.isRequired,
  /**
   * Title of the card
   */
  title: PropTypes.string.isRequired,
  /**
   * Description of the card
   */
  description: PropTypes.string.isRequired,
  /**
   * Data to be displayed in the modal
   */
  modal: PropTypes.object.isRequired,
};

FullWidthCard.defaultProps = {
  removeCard: null,
  addCard: null,
  type: 'FULL_WIDTH_CARD',
  image: '',
  title: '',
  description: '',
  modal: {components: [], title: ''},
};
